import axios from "axios";
import { loadConfig, getToken } from "../utility";

let config = await loadConfig();

export default function BookingController() {
	const token = getToken();

	//> getTopResidences
	this.getAdvertisements = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					adsId: "",
					imageUrl: "",
					linkUrl: 3,
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetAdvertisements?page=1&size=7`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getTopResidences
	this.getTopResidences = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					residenceId: "",
					name: "",
					cityName: "",
					imageUrl: "",
					rate: 3,
					minPrice: 10000000,
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetResidences?sort=top&page=1&size=7`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getCities
	this.getCities = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					cityId: "",
					name: "",
					imageUrl: "",
					maxOffPercent: 50,
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetCities`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getOffResidences
	this.getOffResidences = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					residenceId: "",
					name: "",
					cityName: "",
					shortAddress: "",
					imageUrl: "",
					rate: 3,
					minPrice: 10000000,
					maxOffPercent: 25,
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetResidences?sort=off&page=1&size=12`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getResidence
	this.getResidence = async function (residenceId) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				residenceId: "",
				name: "",
				cityName: "",
				rate: 0,
				address: "",
				latitude: 0,
				longitude: 0,
				startTime: "",
				endTime: "",
				totalRooms: 0,
				totalCapacity: 0,
				notes: "",
				images: [],
				publicFacilities: [{ name: "", notes: "" }],
				roomsFacilities: [{ name: "", notes: "" }],
				notProvidedFacilities: [{ name: "", notes: "" }],
				laws: [{ imageUrl: "", title: "", quickNote: "", notes: "" }],
				places: [
					{ name: "", distance: 0, duration: 0, vehicleType: "OnFoot/Riding" },
				],
				roomTypes: [
					{
						residenceRoomTypeId: "",
						name: "",
						roomTypeName: "",
						total: 0,
						roomPrice: 0,
						offPercent: 0,
						extraPersonPrice: 0,
						imageUrl: "",
						totalCapacity: 0,
						totalExtraCapacity: 0,
					},
				],
			},
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/getResidence/?residenceId=${residenceId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getRemainResidenceRoomTypes
	this.getRemainResidenceRoomTypes = async function (
		residenceId,
		startdate,
		duration
	) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					residenceRoomTypeId: "",
					totalRemain: "",
				},
			],
		};
		let startDateParam = null;
		if (startdate) startDateParam = startdate.toISOString().substring(0, 10);

		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetRemainResidenceRoomTypes/?residenceId=${residenceId}&startDate=${startDateParam}&duration=${duration}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> prepareReservation
	this.prepareReservation = async function (
		residenceRoomTypeId,
		startDate,
		duration
	) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				owner: {
					fullName: "",
					nationalCode: "",
					mobile: "",
					email: "",
				},
				residenceName: "",
				startDate: "",
				startTime: "",
				duration: 0,
				endDate: "",
				endTime: "",
				offPercent: 0,
				name: "",
				roomTypeName: "",
				totalCapacity: 0,
				totalExtraCapacity: 0,
				roomPrice: 0,
				extraDependentPersonPrice: 0,
				extraNonDependentPersonPrice: 0,
				peakRoomPrice: 0,
				peakExtraDependentPersonPrice: 0,
				peakExtraNonDependentPersonPrice: 0,
				days: [
					{
						day: "",
						offPercent: 0,
						isPeak: false,
					},
				],
			},
		};
		try {
			startDate = new Date(startDate).toISOString();
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/prepareReservation/?residenceRoomTypeId=${residenceRoomTypeId}&startDate=${startDate}&duration=${duration}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> createReservation
	this.createReservation = async function (
		startDate,
		duration,
		residenceRoomTypeId,
		persons,
		couponCode
	) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: "",
		};
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/createReservation`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: {
					startDate: startDate,
					duration: duration,
					residenceRoomTypeId: residenceRoomTypeId,
					persons: persons,
					couponCode: couponCode,
					returnUrl: window.location.origin + "/#call-back-reservation",
				},
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getReservation
	this.getReservation = async function (code) {
		let result = { isSuccess: true, message: "Success", value: null };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetReservation?code=${code}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getReservation
	this.getReservations = async function () {
		let result = { isSuccess: true, message: "Success", value: [] };
		const token = getToken();
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/GetReservations`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> cancelReservation
	this.cancelReservation = async function (code) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: "",
		};
		try {
			const response = await axios.request({
				method: "post",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}OffPlus/CancelReservation`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: {
					code: code,
				},
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	}; //>
}
